export const QB_TEAM_KEY = '@QB_TEAM_KEY';
